(function() {
    // Function to check if Google Maps is loaded
    function checkGoogleMapsLoaded() {
        if (window.google && window.google.maps) {
            initializeMaps(window.google.maps);
        } else {
            setTimeout(checkGoogleMapsLoaded, 100);
        }
    }

    // Initialize maps once API is loaded
    function initializeMaps(maps) {
        // Find all map containers
        const mapContainers = document.querySelectorAll('.acf-map');

        if (!mapContainers.length) {
            console.log('No map containers found on page');
            return;
        }

        // Loop through map containers and initialize each
        mapContainers.forEach(function(container) {
            try {
                // Get map data from data attributes
                const mapData = container.dataset.map ? JSON.parse(container.dataset.map) : null;

                if (!mapData) {
                    console.error('No map data found for container');
                    return;
                }

                // Create position object
                const position = {
                    lat: parseFloat(mapData.lat),
                    lng: parseFloat(mapData.lng)
                };

                // Map options
                const mapOptions = {
                    zoom: 16,
                    center: position,
                    mapTypeId: 'roadmap',
                    scrollwheel: false,
                    disableDefaultUI: true,
                    zoomControl: true,
                    mapTypeControl: false,
                    streetViewControl: false,
                    fullscreenControl: false,
                    // styles: [
                    //     {
                    //         "featureType": "all",
                    //         "elementType": "geometry.fill",
                    //         "stylers": [{"weight": "2.00"}]
                    //     },
                    //     {
                    //         "featureType": "all",
                    //         "elementType": "labels",
                    //         "stylers": [
                    //             {"visibility": "on"},
                    //             {"saturation": -100},
                    //             {"lightness": 30}
                    //         ]
                    //     },
                    //     {
                    //         "featureType": "all",
                    //         "elementType": "labels.text",
                    //         "stylers": [
                    //             {"fontSize": "8px"},
                    //             {"lightness": 30}
                    //         ]
                    //     },
                    //     {
                    //         "featureType": "poi",
                    //         "elementType": "labels",
                    //         "stylers": [
                    //             {"visibility": "simplified"},
                    //             {"lightness": 30}
                    //         ]
                    //     },
                    //     {
                    //         "featureType": "poi.business",
                    //         "elementType": "labels",
                    //         "stylers": [
                    //             {"visibility": "off"}
                    //         ]
                    //     },
                    //     {
                    //         "featureType": "road",
                    //         "elementType": "labels.text",
                    //         "stylers": [
                    //             {"fontSize": "8px"},
                    //             {"lightness": 30}
                    //         ]
                    //     },
                    //     {
                    //         "featureType": "transit",
                    //         "elementType": "labels",
                    //         "stylers": [
                    //             {"visibility": "simplified"},
                    //             {"lightness": 30}
                    //         ]
                    //     }
                    // ]
                };

                // Create the map
                const map = new maps.Map(container, mapOptions);

                // Add default marker
                new maps.Marker({
                    position: position,
                    map: map,
                    title: mapData.address
                });

                // Center map on window resize
                window.addEventListener('resize', function() {
                    const center = map.getCenter();
                    maps.event.trigger(map, 'resize');
                    map.setCenter(center);
                });
            } catch (error) {
                console.error('Error initializing individual map:', error);
            }
        });
    }

    // Start initialization when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', checkGoogleMapsLoaded);
    } else {
        checkGoogleMapsLoaded();
    }
})();
